import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import moment from "moment";
import DatePicker from "react-datepicker";

import { generateEmployeePayrollRequest } from "../../api/payroll";
import Reports from "./Tabs/Reports";
import Statement from "./Tabs/Statement";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect";
import { employeeSelectOptionRequest } from "api/employee";

class Payroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAction: null,
            selectedEmployee: null,
            employeeSelectOptions: [],
            selectedMonth: null,
            selectedPeriod: null,
            payrollData: null,
            payrollStatement: null,
            successMessage: null,
            errorMessage: null,
            loading: false,
            activeTab: "report",
            dataGot: false,
        };
    }

    handleActionSelect = (e) => {
        const { target } = e;
        const { name, value } = target;
        const {
            employeeSelectOptions,
            selectedMonth,
            selectedPeriod,
            payrollData,
            payrollStatement,
        } = this.state;
        this.setState({
            [name]: value,
        });
        if (name === "selectedAction" && value === "employee") {
            if (!employeeSelectOptions || employeeSelectOptions.length === 0) {
                employeeSelectOptionRequest({},
                    (result) =>
                        this.setState({ employeeSelectOptions: result }),
                    (error) =>
                        this.setState({ errorMessage: "There was an error" }),
                );
            }
        }

        if (
            name === "selectedEmployee" &&
            (selectedMonth || selectedPeriod || payrollData || payrollStatement)
        ) {
            this.setState({
                selectedMonth: null,
                selectedPeriod: null,
                payrollData: null,
                payrollStatement: null,
            });
        }
    };

    onChangeDate = (date, field) => {
        let value = moment(date).format("YYYY-MM-DD");

        this.setState({
            [field]: value,
        });
    };

    generatePayroll = () => {
        let startDate;
        let endDate;

        this.setState({
            loading: true,
        });

        const {
            selectedEmployee,
            selectedMonth,
            selectedPeriod,
            employeeSelectOptions
        } = this.state;

        switch(selectedPeriod) {
            /*case 'wholeMonth': 
                startDate = selectedMonth;
                endDate = moment(selectedMonth, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
            break;*/
            case 'firstHalf':
                startDate = selectedMonth;
                endDate = moment(selectedMonth, 'YYYY-MM-DD').add(14, 'days').format('YYYY-MM-DD');
            break;
            case 'secondHalf':
                startDate = moment.utc(selectedMonth, 'YYYY-MM-DD').add(15, 'days').format('YYYY-MM-DD');
                endDate = moment.utc(selectedMonth, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
            break
            default: console.log('In default case')
        }

        const data = {
            selectedEmployee: selectedEmployee._id,
            startDate,
            endDate
        }

        this.setState({
            loading: true
        });

        let employeeDateHired = selectedEmployee.dateHired;
        let employeeDateDischarged = selectedEmployee.dateDischarged;

        const hiredDuringPeriod = moment(employeeDateHired).isBetween(startDate, endDate);
        const hiredAfterPeriod = moment(employeeDateHired).isAfter(endDate);
        const dischargedDuringPeriod = moment(employeeDateDischarged).isBetween(startDate, endDate);
        const dischargedBeforePediod = moment(employeeDateDischarged).isBefore(startDate);

        
        if (hiredDuringPeriod) {
            this.setState({
                errorMessage: "Employee was hired during the period selected",
                loading: false
            })
            return;
        }

        if (hiredAfterPeriod) {
            this.setState({
                errorMessage: "Employee was hired after the period selected",
                loading: false
            })
            return;
        }

        if (dischargedDuringPeriod) {
            this.setState({
                errorMessage: "Employee was discharged during the period selected",
                loading: false
            })
            return;
        }
        
        if (dischargedBeforePediod) {
            this.setState({
                errorMessage: "Employee was discharged before the period selected",
                loading: false
            })
            return;
        }

        generateEmployeePayrollRequest(data,
            result => this.generateSuccess(result),
            error => this.generateFail(error)
        );
    }

    generateSuccess = (result) => {
        console.log(result);
        this.setState({
            errorMessage: null,
            successMessage: "Payroll generated successfully",
            payrollData: result.payrollData,
            payrollStatement: result.payrollStatement,
            loading: false,
            dataGot: true,
        });
    };

    generateFail = (error) => {
        console.log(error.message)
        this.setState({
            errorMessage: "There was an error generating payroll",
            successMessage: null,
            loading: false,
        });
    };

    clearPayroll = () => {
        this.setState({
            selectedAction: "",
            selectedEmployee: null,
            selectedMonth: null,
            selectedPeriod: null,
            payrollData: null,
            payrollStatement: null,
            successMessage: null,
            errorMessage: null,
            loading: false,
            dataGot: false,
        });
    };

    changeActiveTab = (e, tabState, tadName) => {
        e.preventDefault();
        this.setState({
            [tabState]: tadName,
        });
    };

    onChangePeriod = (e) => {
        const { value, name } = e.target;

        this.setState({
            [name]: value,
        });
    };

    renderActiveTab = (tab) => {
        const { payrollData, payrollStatement } = this.state;

        switch (tab) {
            case "report":
                return <Reports data={payrollData} />;
            case "statement":
                return <Statement data={payrollStatement} />;
            default:
                return <p>Default case renderActiveTab</p>;
        }
    };

    handleChange = (employeeValue) => {
        this.setState({ selectedEmployee: employeeValue.data });
    };

    render() {
        const {
            selectedAction,
            selectedEmployee,
            payrollData,
            loading,
            activeTab,
            dataGot,
            errorMessage,
            selectedPeriod
            
        } = this.state;

        const tabs = [
            {
                title: "Report",
                type: "report",
            },
            {
                title: "Statement",
                type: "statement",
            },
        ];

        const selectedMonth = this.state.selectedMonth
            ? moment(this.state.selectedMonth, "YYYY-MM").toDate()
            : "";

        return (
            <div className="content">
                <Grid fluid>
                    {!dataGot && (
                        <>
                            <Row>
                                <Col md={12}>
                                    <FormGroup controlId="formControlsSelect">
                                        <ControlLabel>
                                            Select Action
                                        </ControlLabel>
                                        <FormControl
                                            onChange={this.handleActionSelect}
                                            componentClass="select"
                                            name="selectedAction"
                                            value={selectedAction}
                                        >
                                            <option value="">Select</option>
                                            <option value="employee">
                                                Generate Payroll
                                            </option>
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {selectedAction === "employee" && (
                                <Row>
                                    <Col md={12}>
                                        <FormGroup controlId="formControlsSelect">
                                            <ControlLabel>
                                                Select employee
                                            </ControlLabel>
                                            <EmployeeAsyncSelect
                                                onChange={this.handleChange}
                                            />
                                            {/* <FormControl 
                        onChange={this.handleActionSelect}
                        componentClass="select" 
                        name="selectedEmployee"
                        value={selectedEmployee}
                      >
                      <option value="">Select</option>
                      {employeeSelectOptions.map(option => {
                        return (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        );
                      })}
                    </FormControl> */}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}
                            {selectedAction === "employee" && selectedEmployee && (
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <ControlLabel>
                                                Month/Year
                                            </ControlLabel>
                                            <DatePicker
                                                selected={selectedMonth}
                                                onChange={(date) =>
                                                    this.onChangeDate(
                                                        date,
                                                        "selectedMonth",
                                                    )
                                                }
                                                dateFormat="MM/yyyy"
                                                className="dateInput"
                                                dropdownMode="select"
                                                showMonthYearPicker
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <ControlLabel>Period</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                type="select"
                                                value={selectedPeriod}
                                                name="selectedPeriod"
                                                onChange={this.onChangePeriod}
                                            >
                                                <option value="">Select</option>
                                                {/*<option value="wholeMonth">
                                                    Whole month
                                                </option>*/}
                                                <option value="firstHalf">
                                                    First half
                                                </option>
                                                <option value="secondHalf">
                                                    Second Half
                                                </option>
                                            </FormControl>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}
                            {selectedAction === "employee" &&
                                selectedEmployee &&
                                selectedMonth &&
                                selectedPeriod &&
                                !payrollData && (
                                    <Row>
                                        <Button
                                            bsStyle="primary"
                                            pullRight
                                            fill
                                            onClick={() =>
                                                this.generatePayroll()
                                            }
                                        >
                                            {loading
                                                ? "Generating..."
                                                : "Generate Payroll"}
                                        </Button>
                                    </Row>
                                )}
                        </>
                    )}
                    {payrollData && (
                        <div>
                            <div className="form-header">
                                <h3 className="text-secondary font-weight-bold">
                                    Payroll
                                </h3>
                                <Button
                                    className="btn btn-primary top-btn"
                                    onClick={() => this.clearPayroll()}
                                >
                                    Clear
                                </Button>
                            </div>
                            <div
                                className="tabs-nav"
                                style={{ marginBottom: "20px" }}
                            >
                                {tabs.map((tab) => {
                                    return (
                                        <button
                                            data-toggle="tab"
                                            href="#pablo"
                                            className={
                                                this.state.activeTab ===
                                                tab.type
                                                    ? "tab-button active"
                                                    : "tab-button"
                                            }
                                            onClick={(e) =>
                                                this.changeActiveTab(
                                                    e,
                                                    "activeTab",
                                                    tab.type,
                                                )
                                            }
                                        >
                                            {tab.title}
                                        </button>
                                    );
                                })}
                            </div>
                            {this.renderActiveTab(activeTab)}
                        </div>
                    )}
                    {errorMessage && (
                        <Row className="pt-3 mt-3">
                            <div
                                className="alert alert-danger"
                                style={{ marginTop: "10px" }}
                            >
                                {errorMessage}
                            </div>
                        </Row>
                    )}
                </Grid>
            </div>
        );
    }
}

export default Payroll;
